import { FormikErrors } from "formik";
import React from "react";
import { Form, Card } from "react-bootstrap";

export type ErrorArray = Array<{ error: string | object | ErrorArray }>;

export const RenderError: React.FC<{ error: string | object | ErrorArray }> = ({
  error,
}) => {
  if (typeof error == "string") {
    return <Form.Text className="text-danger">{error}</Form.Text>;
  }
  if (Array.isArray(error)) {
    return (
      <>
        {error.map((x, index) => (
          <div key={index}>
            <RenderError error={x} />
          </div>
        ))}
      </>
    );
  }
  if (typeof error == "object") {
    return (
      <>
        {Object.keys(error).length > 0 && (
          <div>
            {Object.keys(error).map((x) => (
              <div key={x}>
                <RenderError error={error[x]} />
              </div>
            ))}
          </div>
        )}
      </>
    );
  }
};

export const ErrorsListCard: React.FC<{
  errors?: FormikErrors<any>;
  title?: string;
}> = ({ errors, title }) => {
  if (!errors || Object.keys(errors).length == 0) return null;
  title = title ?? "Manglende information";
    return (
        <Card className="mt-3" style={{ color: "black" }}>
      <Card.Header>
        <h3>{title}</h3>
      </Card.Header>
      <Card.Body>
        <p>Følgende felter er ikke udfyldt korrekt. Rul op igen, og ret til.</p>
        <RenderError error={errors} />
      </Card.Body>
    </Card>
  );
};
